export default {
  src: new URL(
    "./IntroPagePlaceholder.jpg?as=jpg",
    import.meta.url
  ) as any as string,
  srcSet: {
    webp: `${
      new URL(
        "./IntroPagePlaceholder.jpg?as=webp&width=2200?withoutEnlargement=true",
        import.meta.url
      ) as any as string
    } 2200w,${
      new URL(
        "./IntroPagePlaceholder.jpg?as=webp&width=1800?withoutEnlargement=true",
        import.meta.url
      ) as any as string
    } 1800w,${
      new URL(
        "./IntroPagePlaceholder.jpg?as=webp&width=1400?withoutEnlargement=true",
        import.meta.url
      ) as any as string
    } 1400w,${
      new URL(
        "./IntroPagePlaceholder.jpg?as=webp&width=1000?withoutEnlargement=true",
        import.meta.url
      ) as any as string
    } 1000w,${
      new URL(
        "./IntroPagePlaceholder.jpg?as=webp&width=600?withoutEnlargement=true",
        import.meta.url
      ) as any as string
    } 600w,`,
    jpg: `${
      new URL(
        "./IntroPagePlaceholder.jpg?as=jpg&width=2200?withoutEnlargement=true",
        import.meta.url
      ) as any as string
    } 2200w,${
      new URL(
        "./IntroPagePlaceholder.jpg?as=jpg&width=1800?withoutEnlargement=true",
        import.meta.url
      ) as any as string
    } 1800w,${
      new URL(
        "./IntroPagePlaceholder.jpg?as=jpg&width=1400?withoutEnlargement=true",
        import.meta.url
      ) as any as string
    } 1400w,${
      new URL(
        "./IntroPagePlaceholder.jpg?as=jpg&width=1000?withoutEnlargement=true",
        import.meta.url
      ) as any as string
    } 1000w,${
      new URL(
        "./IntroPagePlaceholder.jpg?as=jpg&width=600?withoutEnlargement=true",
        import.meta.url
      ) as any as string
    } 600w,`,
  },
};
